<app-header-modal [color]="'secondary-2'" title="Detalhes da ordem">
  <i class="uil uil-times" (click)="close()" status></i>
</app-header-modal>

<div class="content">
  <mat-tab-group mat-align-tabs="center">
    <mat-tab label="Detalhes de Ordem">
      <div class="up-modal">
        <div class="left">
          <div class="column">
            <app-info-oc-or-nfe label="Nº da Ordem" [value]="orderData?.number ? orderData.number : '---' "></app-info-oc-or-nfe>
            <app-info-oc-or-nfe label="Razão Social" [value]="orderData?.client?.name ? orderData.client.name : '---' " ></app-info-oc-or-nfe>
            <app-info-oc-or-nfe label="Endereço" [value]="orderData?.address?.street ? orderData.address.street : '---' "></app-info-oc-or-nfe>
          </div>
          <div class="column two">
            <app-info-oc-or-nfe label="Data/Hora de Emissão" [value]="timestampToDate(orderData?.issuedAt)"></app-info-oc-or-nfe>
            <app-info-oc-or-nfe label="CPF/CNPJ Fornecedor" [value]="orderData?.client?.doc ? orderData.client.doc : '---' "></app-info-oc-or-nfe>
            <button *ngIf="orderData.state === stateEnum.RECEIVED"
              [disabled]="!canPerformAction(actionEnum.REMOVE_OUT_ORDER)"
              mat-stroked-button class="alert" (click)="removeOrder()">
              Remover
            </button>
            <button *ngIf="[stateEnum.PREPARING_FOR_DISPATCH, stateEnum.AWAITING_VALIDATION, stateEnum.BLOCKED_TO_DISPATCH, stateEnum.READY_TO_PACKING].includes(orderData.state)"
              [disabled]="!canPerformAction(actionEnum.RESET_OUT_ORDER)"
              class="reset" mat-stroked-button (click)="resetOrder()">
              Retroceder
            </button>
          </div>
        </div>
      
        <div class="right">
          <app-provider-contact 
            [provider]="{
                          name: orderData.client?.name ? orderData.client.name : '---',
                          phone: orderData.client?.phone ? orderData.client.phone : '---',
                          email: orderData.client?.email ? orderData.client.email : '---'
                        }">
          </app-provider-contact>
          <app-progress-card *ngIf="data.orderType === orderTypeEnum.IN_SEPARATION"
            [title]="'Progresso da Separação'"
            [value]="progressValue">
          </app-progress-card>
        </div>
      </div>
      <div class="table">
        <app-table-header>
          <app-table-header-column name="sku">
            <span content>Código do Item</span>
          </app-table-header-column>
          <app-table-header-column name="description">
            <span content>Descrição</span>
          </app-table-header-column>
          <app-table-header-column name="quantity">
            <span content>Quantidade</span>
          </app-table-header-column>
          <app-table-header-column name="status" *ngIf="data.orderType === orderTypeEnum.IN_SEPARATION">
            <span content>Estado</span>
          </app-table-header-column>
          <app-table-header-column name="availability" *ngIf="data.orderType === orderTypeEnum.RECEIVED">
            <span content>Disponibilidade do produto</span>
          </app-table-header-column>
        </app-table-header>

        <app-table-items>
          <app-table-item *ngFor="let p of orderData?.products; let odd = odd" [isOdd]="odd">
            <app-table-column name="sku">
              <span content>{{ p?.sku || '-' }}</span>
            </app-table-column>
            <app-table-column name="description">
              <span content>{{ p?.description || '-' }}</span>
            </app-table-column>
            <app-table-column name="quantity">
              <span content>{{ p?.quantity || '-' }}</span>
            </app-table-column>
            <app-table-column name="status" *ngIf="data.orderType === orderTypeEnum.IN_SEPARATION">
              <span content>{{ translateProductStatus(p) }}</span>
            </app-table-column>
            <app-table-column name="availability" *ngIf="data.orderType === orderTypeEnum.RECEIVED">
              <span content>
                <div *ngIf="checkingAvailability" class="spinner-cell" aria-live="polite">
                  <mat-progress-spinner [diameter]="18" mode="indeterminate"></mat-progress-spinner>
                </div>
                <div *ngIf="!checkingAvailability && isProductAvailable(p.sku) !== null">
                  <span class="avail-dot" aria-hidden="true"
                    [ngClass]="{'ok': isProductAvailable(p.sku), 'missing': !isProductAvailable(p.sku)}">
                  </span>
                </div>
              </span>
            </app-table-column>
          </app-table-item>
          <div class="empty-table" *ngIf="!orderData?.products?.length">
            NÃO EXISTEM PRODUTOS.
          </div>
        </app-table-items>
      </div>
    </mat-tab>

    <mat-tab label="Plano" *ngIf="orderData?.executionPlan">
      <app-out-order-execution-plan [executionPlan]="orderData?.executionPlan"></app-out-order-execution-plan>
    </mat-tab>
  </mat-tab-group>
</div>
